import GroupFolderAction from './GroupFolderAction';
import { HttpStatusCode } from 'owa-http-status-codes';

export default function getSuccessStatusCode(action: GroupFolderAction): number {
    let successStatusCode: number;

    switch (action) {
        case GroupFolderAction.CreateFolder:
        case GroupFolderAction.CopyFolder:
        case GroupFolderAction.MoveFolder:
            successStatusCode = HttpStatusCode.Created;
            break;
        case GroupFolderAction.GetFolder:
        case GroupFolderAction.RenameFolder:
            successStatusCode = HttpStatusCode.OK;
            break;
        default:
            throw new Error('This GroupFolderAction is not supported');
    }

    return successStatusCode;
}
